import baseClient from './baseClient';

const getPaymentToken = async () => {
    return baseClient.get('payment/token/generate');
}

const generateTransaction = async (nonce) => {
    return baseClient.post('payment', { nonce });
}

export {
    getPaymentToken,
    generateTransaction
}
